package org.example.zone360.pages.dashboard.coaches

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.createCheckoutAddon
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CountOptionalInputField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Composable
fun CoachesCount(
    onDialogDismiss: () -> Unit,
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    toastMessage: (String) -> Unit

){
    val scope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }
    var isError by remember { mutableStateOf(false) }
    scope.launch {
        (document.getElementById(Res.Id.count) as HTMLInputElement).value = "1"
    }
    Box(
        modifier = Modifier.fillMaxSize()
            .position(Position.Fixed)
            .zIndex(999)
            .backgroundColor(Colors.Black.copyf(alpha = 0.5f)),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(if (breakpoint < Breakpoint.MD) 90.percent else 475.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .boxShadow(blurRadius = 32.px, color = Colors.Black.copyf(alpha = 0.25f))
                .padding(24.px)
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        FieldTitleTextNormalSimple(
                            "Increase Coaches Limit",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )
                    }

                    FaXmark(
                        modifier = Modifier
                            .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer)
                            .onClick { onDialogDismiss() },
                        size = IconSize.LG
                    )

                }
                FieldTitleTextNormalSimple(
                    "No. of Coaches",
                    fontSize = 16.px,
                    fontWeight = 400,
                    width = 100.percent,
                    marginBottom = 5.px
                )
                Box(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                    CountOptionalInputField(
                        onValueChange = {
                            isError = false
                        },
                        inputType = InputType.Number,
                        number = true,
                        placeHolder = "",
                        id = Res.Id.count,
                        width = 100.percent,
                        noNegative = true
                    )
                }
                if (isError) {
                    FieldTitleTextNormalSimple(
                        "Please enter valid count",
                        fontSize = 11.px,
                        fontWeight = 400,
                        color = sitePalette.textErrorColor.rgb
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth().gap(10.px),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                   CommonButton(
                       text = "Continue",
                       width = 80.px,
                       height = 39.px,
                       isLoading = isLoading,
                       onCLick = {
                           scope.launch {
                               val countInput = (document.getElementById(Res.Id.count) as HTMLInputElement).value
                               if (countInput.isBlank() || countInput <= "0") {
                                   isError = true
                                   return@launch
                               }
                               isLoading = true
                               try {
                                   val response = createCheckoutAddon(
                                       count = countInput,
                                       organization = AppGlobal.userData.organization,
                                       userID = AppGlobal.userData.uid,
                                       email = AppGlobal.userData.email,
                                       stripCustomerID = if (AppGlobal.userData.stripCustomerID == null) "" else  AppGlobal.userData.stripCustomerID!!
                                   )
                                   if (response.checkout_url != null) {
                                       val url = response.checkout_url
                                       if (url.isNotBlank()) {
                                           kotlinx.browser.window.open(url, "_self")
                                       }

                                   } else {
                                       toastMessage(response.error!!)
                                       showToast("toastError")
                                   }
                               } catch (e: Throwable) {
                                   toastMessage(e.message.toString())
                                   showToast("toastError")
                               }finally {
                                   isLoading = false
                               }
                           }
                       }
                   )
                    CommonButton(
                        text = "Cancel",
                        width = 70.px,
                        height = 39.px,
                        onCLick = {
                            onDialogDismiss()
                        }
                    )

                }
            }
        }

        }
}